import { FileSpreadsheet, FileText } from "lucide-react";
import { Button } from "./button";
import { RadioGroup, RadioGroupItem } from "./radio-group";
import { Label } from "./label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./dialog";

const ExportFormatDialog = ({
  open,
  onOpenChange,
  onExport,
  title = "Export",
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Choose your preferred export format:
          </p>
          <div className="grid grid-cols-2 gap-4">
            <Button
              variant="outline"
              className="h-24 flex-col gap-2"
              onClick={() => {
                onExport("excel");
                onOpenChange(false);
              }}
              data-testid="export-excel-btn"
            >
              <FileSpreadsheet className="w-8 h-8 text-green-600" />
              <span>Excel (.xlsx)</span>
            </Button>
            <Button
              variant="outline"
              className="h-24 flex-col gap-2"
              onClick={() => {
                onExport("pdf");
                onOpenChange(false);
              }}
              data-testid="export-pdf-btn"
            >
              <FileText className="w-8 h-8 text-red-600" />
              <span>PDF</span>
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { ExportFormatDialog };
